
import { Vue, Component, Prop, PropSync, Ref } from 'vue-property-decorator'
import { LicenseInfo } from './liquor-license'

@Component({})
export default class LiquorLicenseFields extends Vue {
  @Ref() public readonly licenseNumberInput!: HTMLInputElement & { validate: () => void }
  @Ref() public readonly licenseFileInput!: HTMLInputElement & { validate: () => void }

  @Prop({type: Boolean})
  public required!: boolean

  @Prop({type: Boolean, default: false})
  public loading!: boolean

  @PropSync('number', {type: String})
  public licenseNumber!: string

  @PropSync('file', {type: File})
  public licenseFile!: File

  public licenseNumberRules = [
    (v: string) => this.isRequiredValid(v, 'licenseFile') || 'License Number is required'
  ]

  public fileInputRules = [
    (v: File) => this.isRequiredValid(v, 'licenseNumber') || 'License File is required',
    (v: File) => !v || v.size < 10 * 1000000 || 'File size must be less than 10MB'
  ]

  public inputChanged(input: 'number' | 'file') {
    if (
        input === 'number'
        && this.licenseFileInput
        && typeof this.licenseFileInput.validate === 'function'
    ) {
      this.licenseFileInput.validate()
    }
    if (
        input === 'file'
        && this.licenseNumberInput
        && typeof this.licenseNumberInput.validate === 'function'
    ) {
      this.licenseNumberInput.validate()
    }
  }

  private isRequiredValid(v: string | File, otherField: 'licenseNumber' | 'licenseFile') {
    return !!v || (!this.required && !this[otherField])
  }
}

